<template>
  <div class="app-container">
    <el-tabs v-model="type">
      <el-tab-pane name="image">
        <span slot="label"><i class="el-icon-picture-outline"></i> 图片 </span>
        <keep-alive v-if="type === 'image'">
          <attachmentFiles :type="type" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane name="audio">
        <span slot="label"><i class="el-icon-microphone"></i> 音频 </span>
        <keep-alive v-if="type === 'audio'">
          <attachmentFiles :type="type" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane name="video">
        <span slot="label"><i class="el-icon-video-play"></i> 视频 </span>
        <keep-alive v-if="type === 'video'">
          <attachmentFiles :type="type" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane name="document">
        <span slot="label"><i class="el-icon-document"></i> 文档 </span>
        <keep-alive v-if="type === 'document'">
          <attachmentFiles :type="type" />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import attachmentFiles from './components/attachment_files'

export default {
  name: 'List',
  components: { attachmentFiles },

  data() {
    return {
      type: 'image'
    }
  }
}
</script>
<style lang="scss">
</style>
